export default __webpack_public_path__ + "static/media/2-4.a826a2d4.webp";